module.exports = __webpack_public_path__ + "static/media/Peasant_wName.80fd135b.png";